import {useEffect} from "react";
import {usePage} from "@inertiajs/react";

export default function useBodyClass() {
    const {component} = usePage(); // получаем имя текущего компонента Inertia

    useEffect(() => {
        // Разбиваем путь и достаём второй элемент — например 'Basket' из 'Site/Basket/Index'
        const parts = component.split("/");
        const section = parts[1] ? parts[1].toLowerCase() : "unknown";

        const className = `page-${section}`;
        document.body.classList.add(className);
        return () => document.body.classList.remove(className);
    }, [component]);
}
